// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"Footer_footerContainer__ag8yS","footerGithubLink":"Footer_footerGithubLink__8iCuY"};